import { isTransient, Res, useApi } from '../state/api';
import { useLocation } from 'react-router-dom';
import { ApiRedirect } from '../types';

export function useRedirectOnError(resourceError: Error | undefined): { redirect?: ApiRedirect; notFound: boolean } {
	const { pathname } = useLocation();
	const { data: redirect, error: redirectError } = useApi(resourceError ? Res.redirects : null, {
		perma: pathname.replace(/^\//, ''), // remove leading slash
	});
	/*
	 * Only two genuine not-founds confirm a 404, and either one being transient is enough to
	 * withhold it. Without the first check the usual case - a page with no redirect, so the
	 * lookup 404s - turned every upstream hiccup into the not-found page. Without the second, a
	 * page that really is gone but whose redirect lookup was briefly unavailable would be
	 * declared missing while the redirect that would have rescued it was simply unreachable.
	 */
	const confirmed = !!resourceError && !!redirectError && !isTransient(resourceError) && !isTransient(redirectError);
	return { redirect, notFound: confirmed };
}
